import { RouteProps } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import ProductPage from "./pages/ProductPage";
import ScammersLibrary from "./pages/ScammersLibraryPage";
import UploadedFilesPage from "./pages/UploadedFilesPage";
import GeneratePasswordPage from "./pages/GeneratePasswordPage";
import WalletWatchlistPage from "./pages/WalletWatchlistPage";
import IdentityChecker from "./pages/IdentityChecker";
import ContactUsPage from "./pages/ContactUsPage";
import SettingsPage from "./pages/SettingsPage";
import ClientRequestsPage from "./pages/ClientRequestsPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import BlockchainRequestPage from "./pages/BlockchainRequestPage";
import BlockchainStatusPage from "./pages/BlockchainStatusPage";
import BlockchainDetailsPage from "./pages/BlockchainDetailsPage";
import SetNewPassword from "./pages/SetNewPassword/SetNewPassword";
import TrackMaster from "./pages/track-master/TrackMaster";
import { NotFoundPage } from "./pages/NotFoundPage";
import SSOCheckPage from "./pages/SSOCheckPage";
import AgentClientListPage from "./pages/agent-actions/clients-list";
import AgentClientActionPage from "./pages/agent-actions/client-actions";
import AdminManagementPageWrapper from "./pages/admin/AdminManagementPageWrapper";
import CreateAgentPageWrapper from "./pages/admin/CreateAgentPageWrapper";
import CreateSystemUserPageWrapper from "./pages/admin/CreateSystemUserPageWrapper";
import EditSystemUserPageWrapper from "./pages/admin/EditSystemUserPageWrapper";
import SetAgentPasswordPageWrapper from "./pages/admin/SetAgentPasswordPageWrapper";
import UserStatusCheckPageWrapper from "./pages/admin/UserStatusCheckPageWrapper";
import { AgentHomePage } from "./pages/AgentHomePage";

export const routes: RouteProps[] = [
  {
    path: "/",
    Component: Dashboard,
  },
  {
    path: "/product/blockchain-analysis",
    Component: BlockchainRequestPage,
  },
  {
    path: "/blockchain-analysis/new",
    Component: BlockchainRequestPage,
  },
  {
    path: "/blockchain-analysis/status",
    Component: BlockchainStatusPage,
  },
  {
    path: "/blockchain-analysis/status/:id",
    Component: BlockchainDetailsPage,
  },
  {
    path: "/product/:productId",
    Component: ProductPage,
  },
  {
    path: "/track-master",
    Component: TrackMaster,
  },
  {
    path: "/uploaded-files",
    Component: UploadedFilesPage,
  },
  {
    path: "/scammers-library",
    Component: ScammersLibrary,
  },
  {
    path: "/login",
    Component: LoginPage,
  },
  {
    path: "/generate-password",
    Component: GeneratePasswordPage,
  },
  {
    path: "/wallet-watchlist",
    Component: WalletWatchlistPage,
  },
  {
    path: "/identity-theft-checker",
    Component: IdentityChecker,
  },
  {
    path: "/contact-us",
    Component: ContactUsPage,
  },
  {
    path: "/agent-homepage",
    Component: AgentHomePage,
  },
  {
    path: "/settings",
    Component: SettingsPage,
  },
  {
    path: "/client-requests",
    Component: ClientRequestsPage,
  },
  {
    path: "/payment/:paymentProductId?",
    Component: PaymentPage,
  },
  {
    path: "/payment/success",
    Component: PaymentSuccessPage,
  },
  {
    path: "/payment/cancel",
    Component: PaymentCancelPage,
  },
  {
    path: "/initial-password",
    Component: SetNewPassword,
  },
  {
    path: "/sso-check",
    Component: SSOCheckPage,
  },
  {
    path: "/agent/clients",
    Component: AgentClientListPage,
  },
  {
    path: "/agent/client/:clientId",
    Component: AgentClientActionPage,
  },
  {
    path: "/admin",
    Component: AdminManagementPageWrapper,
  },
  {
    path: "/admin/create-agent",
    Component: CreateAgentPageWrapper,
  },
  {
    path: "/admin/create-system-user",
    Component: CreateSystemUserPageWrapper,
  },
  {
    path: "/admin/edit-system-user",
    Component: EditSystemUserPageWrapper,
  },
  {
    path: "/admin/set-agent-password",
    Component: SetAgentPasswordPageWrapper,
  },
  {
    path: "/admin/user-status-check",
    Component: UserStatusCheckPageWrapper,
  },
  {
    path: "*",
    Component: NotFoundPage,
  },
];
